import React from "react"
import Section from "./Section/Section"
import GreenCircle from "../../../images/decorative/green-circle.inline.svg"
import elementSplitter from "./utils/elementSplitter"

type FeatureListProps = {
  children: React.ReactElement
}

const FeatureList = ({ children }: FeatureListProps) => {
  const { paragraphs } = elementSplitter(children)
  //
  return (
    <>
      {paragraphs.map((paragraph, index) => {
        return (
          <Section key={index} direction="row" x="left" y="top">
            <span>
              <GreenCircle style={{ margin: "4px 25px 0 0" }} />
            </span>
            {paragraph}
          </Section>
        )
      })}
    </>
  )
}

export default FeatureList
